<template>
  <router-view></router-view>
</template>

<script>
import { onMounted, ref, watch } from '@vue/composition-api';
import useAuth from '@/api/auth';
import { loadLanguageAsync } from '@/i18n-setup';
import { provide } from 'vue-demi';

export default {
  name: 'App',
  metaInfo: {
    title: 'PixelAdmin'
  },
  setup(props, context) {
    const { user, loadUser, token, profile, loadProfile } = useAuth();

    provide('user', user);

    watch(
      () => profile,
      () => {
        const language = profile.value.objectProperties.find(
          item => item.key === 'programLanguage'
        )?.value;

        const theme = profile.value.objectProperties.find(
          item => item.key === 'programTheme'
        )?.value;

        context.root.$i18n.locale = language;

        if (theme === 'classic') {
          context.root.$vuetify.theme.dark = false;
        } else if (theme === 'dark') {
          context.root.$vuetify.theme.dark = true;
        } else {
          if (window.matchMedia('(prefers-color-scheme)').media !== 'not all') {
            window.matchMedia('(prefers-color-scheme: dark)').addListener(e => {
              if (theme === 'system') {
                context.root.$vuetify.theme.dark = e.matches;
              }
            });
          }
          context.root.$vuetify.theme.dark =
            window.matchMedia &&
            window.matchMedia('(prefers-color-scheme: dark)').matches;
        }
      },
      {
        deep: true
      }
    );

    onMounted(async () => {
      if (token.value && !user.value) {
        await loadLanguageAsync();
        await loadUser();
      }
    });
  }
};
</script>

<style lang="sass">
@import './styles/main.sass'
</style>

<style lang="scss">
.v-data-table-header th[role='columnheader'] span {
  font-size: 14px;
  font-weight: 500;
}
.v-data-table__wrapper table tbody tr td.text-start {
  white-space: nowrap;
  text-overflow: ellipsis;
}
.regular16 {
  font-size: 16px !important;
  font-weight: 400 !important;
}
.regular14 {
  font-size: 14px !important;
  font-weight: 400 !important;
}

.theme--dark.v-application {
  background-color: #1e1e1e !important;
}
</style>
